import { useContext } from 'react';
import { PropertyContext } from '../context/PropertyContext';
export const useGetIsUngated = () => useContext(PropertyContext).getIsUngated;